var _path, _circle, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 7.5C3.5 6.09987 3.5 5.3998 3.77248 4.86502C4.01217 4.39462 4.39462 4.01217 4.86502 3.77248C5.3998 3.5 6.09987 3.5 7.5 3.5H16.5C17.9001 3.5 18.6002 3.5 19.135 3.77248C19.6054 4.01217 19.9878 4.39462 20.2275 4.86502C20.5 5.3998 20.5 6.09987 20.5 7.5V16.5C20.5 17.9001 20.5 18.6002 20.2275 19.135C19.9878 19.6054 19.6054 19.9878 19.135 20.2275C18.6002 20.5 17.9001 20.5 16.5 20.5H7.5C6.09987 20.5 5.3998 20.5 4.86502 20.2275C4.39462 19.9878 4.01217 19.6054 3.77248 19.135C3.5 18.6002 3.5 17.9001 3.5 16.5V7.5Z",
    stroke: "#333333"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 11.5,
    r: 2,
    stroke: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11.5H15.5M17.5 13.5V11.65C17.5 11.5672 17.4328 11.5 17.35 11.5H15.5M15.5 11.5V13.5",
    stroke: "#333333",
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.8d0ed0e864896203f3cf576397b0b9d9.svg";
export { ForwardRef as ReactComponent };